import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ForgotPasswordPage from '../components/auth/forgot-password/ForgotPasswordPage'
import { LoginPage } from '../components/auth/login/LoginPage'
import NewPasswordPage from '../components/auth/new-password/NewPasswordPage'

export const AuthRouter = () => {
    return (
        <Switch>
            <Route exact path="/auth/login" component={LoginPage} />
            <Route exact path="/auth/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/auth/new-password" component={NewPasswordPage} />
            {/* <Route exact path="/auth/register" component={RegistePage} /> */}
            <Redirect to="/auth/login" />
        </Switch>

    )
}
